import reducer from './reducer';

export { default as playerActions } from './actions';
export { default as playerSelectors } from './selectors';

export default reducer;
